import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartBar from '../../../components/charts/ChartBar'
import ChartBarSkeleton from '../../../components/skeletons/ChartBarSkeleton'
import { ChartBarThemes } from '../../../components/charts/types/ChartBar'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { GET_STATUS } from '../../../queries/factory'

interface Bucket {
  key: string
  doc_count: number
}
const OrderVolume = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_STATUS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartBarSkeleton />
  if (loading || !data) return <ChartBarSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.aggregation.aggregations) return <p>No data found</p>

  const categories: Array<string> = []
  const seriesData: Array<number> = []
  data?.aggregation?.aggregations?.status?.buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'most-accepting-users'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    }
  }

  const series = [{
    name: 'Aceitações',
    data: seriesData
  }]
  if (!data) return <></>
  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      Volume de Pedidos
    </Typography>
    <ChartBar options={options} series={series} theme={ChartBarThemes.green} height={400} />
  </Paper>
}
export default OrderVolume
